<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="450">
          <v-card>
            <v-card-title class="headline">Delete selected workflow?</v-card-title>
            <v-card-text class="text-xs-left">You are going to delete this selected workflow.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" flat @click="dialog = false">cancel</v-btn>
              <v-btn color="accent" flat @click="deleteWorkflowById" :loading="getLoading" :disable="getLoading">
                delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Details</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-form @submit.prevent="frmSearch">
                <v-container grid-list-xl class="pa-0 ma-0" fluid>
                  <v-layout row wrap>
                    <v-flex xs12 md3>
                      <v-select v-bind:items="getAllCompanies" v-model="workflow.companyId" label="Company code" item-value="id" :error-messages="errors.collect('company code')"
                        v-validate="'required'" data-vv-name="company code" required>
                        <template slot="selection" slot-scope="data">
                          {{ data.item.company_code }} - {{ data.item.description }}
                        </template>
                        <template slot="item" slot-scope="data">
                          {{ data.item.company_code }} - {{ data.item.description }}
                        </template>
                      </v-select>
                    </v-flex>
                    <v-flex xs12 md3>
                      <v-select v-bind:items="getAllDivisions" v-model="workflow.divisionId" label="Division" item-value="id" :error-messages="errors.collect('division')"
                        v-validate="'required'" data-vv-name="division" required>
                        <template slot="selection" slot-scope="data">
                          {{ data.item.initial }} - {{ data.item.description }}
                        </template>
                        <template slot="item" slot-scope="data">
                          {{ data.item.initial }} - {{ data.item.description }}
                        </template>
                      </v-select>
                    </v-flex>

                    <v-flex xs12 md3>
                      <v-select v-bind:items="getAllPlants" v-model="workflow.plantId" label="Plant" item-value="id" :error-messages="errors.collect('plant')"
                        v-validate="'required'" data-vv-name="plant" required>
                        <template slot="selection" slot-scope="data">
                          {{ data.item.plant }} - {{ data.item.description }}
                        </template>
                        <template slot="item" slot-scope="data">
                          {{ data.item.plant }} - {{ data.item.description }}
                        </template>
                      </v-select>
                    </v-flex>

                    <v-flex xs12 md3>
                      <v-select v-bind:items="getAllDepartments" v-model="workflow.departmentId" label="Department" item-value="id" :error-messages="errors.collect('department')"
                        v-validate="'required'" data-vv-name="department" required>
                        <template slot="selection" slot-scope="data">
                          {{ data.item.description }}
                        </template>
                        <template slot="item" slot-scope="data">
                          {{ data.item.description }}
                        </template>
                      </v-select>
                    </v-flex>

                    <v-flex xs12 md3>
                      <v-select v-bind:items="getApprovalProfiles" v-model="workflow.approvalProfileId" label="Approval profile" item-value="id"
                        clearable>
                        <template slot="selection" slot-scope="data">
                          {{ data.item.description }}
                        </template>
                        <template slot="item" slot-scope="data">
                          {{ data.item.description }}
                        </template>
                      </v-select>
                    </v-flex>
                    <v-flex xs6 md2>
                      <v-btn block color="grey lighten-3" @click="frmSearch()">search</v-btn>
                    </v-flex>
                    <v-flex xs6 md2>
                      <v-btn block color="grey lighten-3" @click="loadWorkflow()">show all</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>

              </v-form>
            </v-flex>

          </v-layout>
        </v-card-text>
        <v-flex xs12>
          <v-card flat class="elevation-0">
            <v-card-title>
              <v-btn dark color="accent" to="/workflow/new">new workflow</v-btn>
              <v-btn 
                dark 
                color="accent" 
                @click="saveToCSV()"
                v-if="this.getWorkflow.length > 0">
                <v-icon left dark>cloud_download</v-icon>
                Download
              </v-btn>
              <v-spacer></v-spacer>
              <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-data-table v-if="!getLoading" loading="true" v-bind:headers="headers" v-bind:items="getWorkflow" v-bind:search="search"
                v-model="selected" item-key="id" :rows-per-page-items="rowsPerPageItems">
                <template slot="headerCell" slot-scope="props">
                  <span>
                    {{ props.header.text }}
                  </span>
                </template>
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left" style="min-width: 160px;">
                    <v-tooltip bottom>
                      <v-btn flat icon @click="editWorkflowById(props.item.id)" color="accent lighten-1" slot="activator">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <span>Change</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <v-btn flat icon @click="toggleDialog(props.item.id)" color="error lighten-1" slot="activator">
                        <v-icon>delete</v-icon>
                      </v-btn>
                      <span>Delete</span>
                    </v-tooltip>
                  </td>
                  <td class="text-xs-left">{{ props.item.id}}</td>
                  <td class="text-xs-left">{{ props.item.company_code}}</td>
                  <td class="text-xs-left">{{ props.item.division_name}}</td>
                  <td class="text-xs-left">{{ props.item.plant_code}}</td>
                  <td class="text-xs-left">{{ props.item.department_code}}</td>
                  <td class="text-xs-left">{{ props.item.approval_profile_description}}</td>
                  <td class="text-xs-left">{{ props.item.requisitioner}}</td>
                  <td class="text-xs-left">{{ props.item.total_value_to === 0 ? `Unlimited` : $options.filters.currency(props.item.total_value_to) }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.approval_level_1 !== 'NULL' ? props.item.approval_level_1 : `-`}}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.approval_level_2 !== 'NULL' ? props.item.approval_level_2 : `-`}}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.approval_level_3 !== 'NULL' ? props.item.approval_level_3 : `-`}}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.approval_level_4 !== 'NULL' ? props.item.approval_level_4 : `-`}}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.approval_level_5 !== 'NULL' ? props.item.approval_level_5 : `-`}}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.approval_level_6 !== 'NULL' ? props.item.approval_level_6 : `-`}}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.approval_level_7 !== 'NULL' ? props.item.approval_level_7 : `-`}}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.approval_level_8 !== 'NULL' ? props.item.approval_level_8 : `-`}}
                  </td>
                </template>
              </v-data-table>
              <v-progress-circular indeterminate color="primary" v-if="getLoading"></v-progress-circular>

    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-card>
    </v-flex>
  </v-layout>
</template>



<script>
import { mapActions, mapGetters } from 'vuex'
import Papa from 'papaparse'
import Blob from 'blob'
import FileSaver from 'file-saver'

export default {
  name: 'workflow-detail',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      workflow: {
        companyId: '',
        plantId: '',
        divisionId: '',
        departmentId: '',
        approvalProfileId: ''
      },
      rowsPerPageItems: [10, 15, 25, { text: 'All', value: -1 }],
      headers: [
        {
          text: 'Actions',
          align: 'left',
          value: 'actions',
          sortable: false
        },
        {
          text: 'ID',
          align: 'left',
          value: 'id'
        },
        {
          text: 'Company code',
          align: 'left',
          value: 'company_code'
        },
        {
          text: 'Division',
          align: 'left',
          value: 'division_name'
        },
        {
          text: 'Plant',
          align: 'left',
          value: 'plant_code'
        },
        {
          text: 'Department',
          align: 'left',
          value: 'department_code'
        },
        {
          text: 'Approval profile',
          align: 'left',
          value: 'approval_profile'
        },
        {
          text: 'Requisitioner',
          align: 'left',
          value: 'requisitioner'
        },
        {
          text: 'Max limit',
          align: 'left',
          value: 'total_value_to'
        },
        {
          text: 'Level 1',
          align: 'left',
          value: 'approval_level_1'
        },
        {
          text: 'Level 2',
          align: 'left',
          value: 'approval_level_2'
        },
        {
          text: 'Level 3',
          align: 'left',
          value: 'approval_level_3'
        },
        {
          text: 'Level 4',
          align: 'left',
          value: 'approval_level_4'
        },
        {
          text: 'Level 5',
          align: 'left',
          value: 'approval_level_5'
        },
        {
          text: 'Level 6',
          align: 'left',
          value: 'approval_level_6'
        },
        {
          text: 'Level 7',
          align: 'left',
          value: 'approval_level_7'
        },
        {
          text: 'Level 8',
          align: 'left',
          value: 'approval_level_8'
        }
      ],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      csv: []
    }
  },
  methods: {
    ...mapActions([
      'fetchWorkflow',
      'deleteWorkflow',
      'fetchAllCompanies',
      'fetchAllDivisions',
      'fetchAllDepartments',
      'fetchAllPlants',
      'fetchAllApprovalProfiles',
      'searchWorkflow'
    ]),

    editWorkflowById: function (id) {
      this.$router.push({ name: 'changeWorkflow', params: { id: id } })
    },

    deleteWorkflowById: function () {
      this.deleteWorkflow(this.selectedId).then(() => {
        this.dialog = false
        let response = this.getResponse
        this.snackbar = true
        this.text =
          response.status === 200
            ? 'Deleted successfully.'
            : response.data.message
        this.color = response.status === 200 ? 'success' : 'error'
      })
    },

    toggleDialog: function (id) {
      this.selectedId = id
      this.dialog = true
    },

    loadWorkflow: function () {
      this.fetchWorkflow()
        .then(() => {
          //  do nothing
        })
        .catch(error => {
          console.log(error)
        })
    },

    frmSearch: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.searchWorkflow(this.workflow)
        }
      })
    },

    parseJSONtoCSV () {
      this.csv = []
      this.getWorkflow.forEach(element => {
        let row = {
          'Company code': null,
          'Plant': null,
          'Division': null,
          'Department': null,
          'Max limit': null,
          'Requisitioner': null,
          'Type': null,
          'Level 1': null,
          'Level 2': null,
          'Level 3': null,
          'Level 4': null,
          'Level 5': null,
          'Level 6': null,
          'Level 7': null,
          'Level 8': null
        }

        row['Company code'] = element.company_code
        row['Plant'] = element.plant_code
        row['Division'] = element.division_name
        row['Department'] = element.department_code
        row['Max limit'] = element.total_value_to === 0 ? `Unlimited` : this.$options.filters.currency(element.total_value_to)
        row['Requisitioner'] = element.requisitioner
        row['Type'] = element.type
        row['Level 1'] = element.approval_level_1 !== 'NULL' ? element.approval_level_1 : ``
        row['Level 2'] = element.approval_level_2 !== 'NULL' ? element.approval_level_2 : ``
        row['Level 3'] = element.approval_level_3 !== 'NULL' ? element.approval_level_3 : ``
        row['Level 4'] = element.approval_level_4 !== 'NULL' ? element.approval_level_4 : ``
        row['Level 5'] = element.approval_level_5 !== 'NULL' ? element.approval_level_5 : ``
        row['Level 6'] = element.approval_level_6 !== 'NULL' ? element.approval_level_6 : ``
        row['Level 7'] = element.approval_level_7 !== 'NULL' ? element.approval_level_7 : ``
        row['Level 8'] = element.approval_level_8 !== 'NULL' ? element.approval_level_8 : ``
        this.csv.push(row)
      })
      return Papa.unparse(this.csv, {headers: true})
    },

    saveToCSV () {
      const blob = new Blob([this.parseJSONtoCSV()], { type: 'text/csv' })
      FileSaver.saveAs(blob, 'workflow_configuration.csv')
    }
  },
  mounted: function () {
    this.loadWorkflow()
    this.fetchAllCompanies()
    this.fetchAllDivisions()
    this.fetchAllDepartments()
    this.fetchAllPlants()
    this.fetchAllApprovalProfiles()
  },
  computed: {
    ...mapGetters([
      'getWorkflow',
      'getLoading',
      'getResponse',
      'getAllCompanies',
      'getAllDivisions',
      'getAllDepartments',
      'getAllPlants',
      'getApprovalProfiles'
    ])
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

<style lang="stylus" scoped>
div {
  text-align: center;
}

.progress-circular {
  margin: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/workflow/WorkflowDetail.vue